<template>
  <div class="screen home" :class="[`${pageColor}-bg`]">
    <h1 v-if="$store.state.loadedTodos.length === 0" key="emptyheading" >{{$store.state.settings.name}}, build habits, focus on what is significant &amp; write not-to-do lists.</h1>
    <h1 v-if="$store.state.loadedTodos.length > 0" key="fullheading" >{{$store.state.settings.name}}, appreciate your rhythm.</h1>
    <transition-group v-if="$store.state.loadedTodos.length > 0" class="todo-list" tag="div">
      <TodoItem
        v-for="todo in $store.getters.undoneTodos"
        :createdAt="todo.createdAt"
        :done="todo.done"
        :key="todo.id"
        :project="todo.project"
        :motive="todo.motive"
        :text="todo.text"
        :category="todo.category"
        :timeNeeded="todo.timeNeeded"
        :timeExpected="todo.timeExpected"
        :dueDate="todo.dueDate"
        :id="todo.id"
        @edit-todo="$emit('edit-todo', $event)"
        @done="checkTodo(todo.id)"
        @delete="deleteTodo"
      />
    </transition-group>
    <p v-if="$store.getters.doneTodos.length > 0" key="doneHeading">appreciate what you archieved</p>
    <transition-group v-if="$store.getters.doneTodos.length > 0" class="todo-list-done" tag="div">
      <TodoItem
        class="donetodo"
        v-for="todo in $store.getters.doneTodos"
        :createdAt="todo.createdAt"
        :done="todo.done"
        :key="todo.id"
        :project="todo.project"
        :motive="todo.motive"
        :text="todo.text"
        :category="todo.category"
        :timeNeeded="todo.timeNeeded"
        :timeExpected="todo.timeExpected"
        :dueDate="todo.dueDate"
        :id="todo.id"
        @delete="deleteTodo"
      />
    </transition-group>
    <div v-if="$store.state.loadedTodos.length === 0" key="emptyState" @click="$emit('show-modal')">
      <div class="empty-state">
        <!--p>every little step brings you closer to your long-term goals.</p-->
        <div class="start">
          <span>add new rhythms</span>
          <TodoIcon :icon="'down'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TodoItem from '@/components/TodoItem.vue';
import TodoIcon from '@/components/TodoIcon.vue';

export default {
  name: 'home',
  components: {
    TodoItem,
    TodoIcon,
  },
  async created() {
    // load todos from vuex as an array, if there is loads of data better don't load all at once
    try {
      await this.$store.dispatch('loadTodos');
    } catch (err) {
      this.$store.commit('addToast', { message: `Sorry. Your rhythms could not be imported: ${err.message}` });
    }
    // load username
    this.name = this.$store.state.settings.name;
  },
  data() {
    return {
      todos: [], // here are all the loadedTodos stored
    };
  },
  methods: {
    // save if todos are done or undone
    checkTodo(todoId) {
      this.$store.dispatch('checkTodo', todoId);
      this.$store.commit('addToast', { message: 'Congratulations for compleeting your rhythm!' });
    },
    // delet todos
    deleteTodo(todoId) {
      this.$store.dispatch('deleteTodo', todoId);
      this.closeTodoModal();
      this.$store.commit('addToast', { message: 'Your rhythm has been deleted.' });
    },
    // close modal
    closeTodoModal() {
      this.todoBeingEdited = null;
      this.showTodoModal = false;
    },
  },
  props: {
    pageColor: String,
    id: Number,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

// empty state
.empty-state
  margin-left: 40px
  height: 60px
  color: black
  width: 85%

  .start
    display: flex
    position: absolute;
    right:0
    margin-bottom: 130px
    margin-right: 38px
    bottom: 0
    padding: 0px !important

    @media $desktop
      margin-bottom: 400px
      margin-right: 1155px

    @media $tablet
      margin-bottom: 330px
      margin-right: 880px

    span
      padding-right: 7px
      font-family: futura-pt, serif
      font-weight: 400
      font-style: normal
      text-transform: uppercase

    .icon
      padding-top: 3px
      color: black
      width: 18px
      height: 18px

      @media $tablet
        opacity: 0

// general screen styles
.screen
  background-image: linear-gradient(150deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  @media $desktop
    background-image: linear-gradient(-7deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  &.v-enter-active,
  &.v-leave-active
    transition: filter 80ms ease

    &.v-enter,
    &.v-leave-to
      filter: blur(1px)
  p
    font-family: futura-pt, serif
    font-weight: 400
    font-style: normal;
    text-transform: uppercase;
    margin-bottom: 10px
    padding-right: 40px
    padding-left: 40px
    font-style: normal
    font-size: 16px !important
    padding-top: 30px !important

    @media $desktop
      padding-left: 200px

    @media $tablet
      padding-left: 200px

    &.v-enter-active,
    &.v-leave-active,
    &.v-move
      transition: transform 2000ms ease, opacity 2000ms ease

      &.v-enter,
      &.v-leave-to
        transform: translateY(60px)
        opacity: 0

    &.v-leave-active
      position: absolute
      width: 100%

  .todo-list
    position: relative

    .todo-item

      &.v-enter-active,
      &.v-leave-active,
      &.v-move
        transition: transform 2000ms ease, opacity 2000ms ease

        &.v-enter,
        &.v-leave-to
          transform: translateY(60px)
          opacity: 0

      &.v-leave-active
        position: absolute
        width: 100%

  .input.v-move
    transition: transform 2000ms ease

  .todo-list-done
    position: relative

    .todo-item
      &.v-enter-active,
      &.v-leave-active,
      &.v-move
        transition: transform 2000ms ease, opacity 2000ms ease

        &.v-enter,
        &.v-leave-to
          transform: translateY(60px)
          opacity: 0

</style>
